import BaseTooltip from "../../sisu/overlay/BaseTooltip.sisu";

const NeoTooltip = (props) => {
    return (
        <BaseTooltip {...props} />
    );
};

export default NeoTooltip;
